// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDrop } from '../models/ApiDrop';
import { HttpFile } from '../http/http';

export class ApiDropsPage {
    'data': Array<ApiDrop>;
    'count': number;
    'page': number;
    'next': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<ApiDrop>",
            "format": ""
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "page",
            "baseName": "page",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "next",
            "baseName": "next",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiDropsPage.attributeTypeMap;
    }

    public constructor() {
    }
}

